import React from 'react';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import getTheme from '../_shared/getTheme';

function Ingenierie() {
  const isMobile = window.innerHeight > window.innerWidth;
  const themeActif = getTheme();

  return (
    <Container maxWidth={false} className={isMobile ? 'conteneur-accueil-mobile' : 'conteneur-accueil'}>
      <Grid container spacing={5}>
        <Grid item xs={12} md={4}>
          <Typography className="text-primary" color="secondary" variant="h3">Ingenierie SyncStats</Typography>
          <Typography variant="body2" className="text-primary">Theme actif: {themeActif}</Typography>
        </Grid>
        <Grid item xs={12} md={8} />
      </Grid>

      <Grid container spacing={5}>
        <Grid item xs={12} md={4}>
          <Link to="/Ingenierie/Deploiements">
            <Card className="bg-primary rounded-lg" style={{ opacity: '0.9' }}>
              <CardActionArea>
                <CardContent>
                  <Typography className="text-primary" gutterBottom variant="h5" component="h2">Assistants de deploiement</Typography>
                  <Typography className="text-primary" variant="body2" color="textSecondary" component="p">
                    Plateforme Web, Site Web, SyncCam et prochains workflows
                  </Typography>
                </CardContent>
              </CardActionArea>
              <CardActions>
                <Button size="small" color="primary">Ouvrir</Button>
              </CardActions>
            </Card>
          </Link>
        </Grid>
      </Grid>

      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Paper className="paperFull">Espace ingenierie pour les procedures techniques.</Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Ingenierie;



// WEBPACK FOOTER //
// src/components/Ingenierie.js